import { Icon } from '@chakra-ui/react';
import {
  MdBarChart,
  MdPerson,
  MdHome,
  MdLock,
  MdOutlineShoppingCart,
} from 'react-icons/md';

// Admin Imports
import MainDashboard from 'views/admin/default';
import NFTMarketplace from 'views/admin/marketplace';
import Profile from 'views/admin/profile';
import DataTables from 'views/admin/dataTables';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import HomePage from 'views/admin/home';

const routes = [
  {
    name: 'Dashboard',
    layout: '/admin',
    path: '/home',
    icon: (
      <Icon as={MdHome as any} width="20px" height="20px" color="inherit" />
    ),
    component: <HomePage />,
  },
  {
    name: 'Main Dashboard',
    layout: '/admin',
    path: '/default',
    icon: (
      <Icon as={MdHome as any} width="20px" height="20px" color="inherit" />
    ),
    component: <MainDashboard />,
  },
  {
    name: 'NFT Marketplace',
    layout: '/admin',
    path: '/nft-marketplace',
    icon: (
      <Icon
        as={MdOutlineShoppingCart as any}
        width="20px"
        height="20px"
        color="inherit"
      />
    ),
    component: <NFTMarketplace />,
    secondary: true,
  },
  {
    name: 'Data Tables',
    layout: '/admin',
    icon: (
      <Icon as={MdBarChart as any} width="20px" height="20px" color="inherit" />
    ),
    path: '/data-tables',
    component: <DataTables />,
  },
  {
    name: 'Profile',
    layout: '/admin',
    path: '/profile',
    icon: (
      <Icon as={MdPerson as any} width="20px" height="20px" color="inherit" />
    ),
    component: <Profile />,
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: (
      <Icon as={MdLock as any} width="20px" height="20px" color="inherit" />
    ),
    component: <SignInCentered />,
  },
];

export default routes;
